module.exports = __webpack_public_path__ + "img/3ภาคกลาง.2a9e8ae3.jpg";